import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Table, Button, Badge, Spinner, Alert } from 'react-bootstrap';
import api from '../../api/axios';

const AdminApprovals = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await api.get('/admin/users.php');
      setUsers(res.data);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to load users');
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (userId, newStatus) => {
    try {
      await api.post('/admin/update-user-status.php', { userId, status: newStatus });
      setUsers(users.map(u => u.id === userId ? { ...u, status: newStatus } : u));
    } catch (err) {
      alert('Failed to update status');
    }
  };

  const getStatusBadge = (status) => {
    const colors = {
      pending: 'warning',
      approved: 'success',
      rejected: 'danger'
    };
    return <Badge bg={colors[status]}>{status}</Badge>;
  };

  if (loading) return <Container className="mt-5 text-center"><Spinner animation="border" /></Container>;

  return (
    <Container className="mt-4">
      <h2>User Approvals</h2>
      <Button variant="outline-primary" className="mb-3" onClick={() => navigate('/dashboard')}>
        Back to Dashboard
      </Button>
      {error && <Alert variant="danger">{error}</Alert>}

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>ID</th>
            <th>Username</th>
            <th>Registered</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u => (
            <tr key={u.id}>
              <td>{u.id}</td>
              <td>{u.username}</td>
              <td>{new Date(u.created_at).toLocaleDateString()}</td>
              <td>{getStatusBadge(u.status)}</td>
              <td>
                {u.status === 'pending' && (
                  <>
                    <Button size="sm" variant="success" onClick={() => updateStatus(u.id, 'approved')} className="me-2">
                      Approve
                    </Button>
                    <Button size="sm" variant="danger" onClick={() => updateStatus(u.id, 'rejected')}>
                      Reject
                    </Button>
                  </>
                )}
                {u.status === 'approved' && (
                  <Button size="sm" variant="warning" onClick={() => updateStatus(u.id, 'pending')}>
                    Mark Pending
                  </Button>
                )}
                {u.status === 'rejected' && (
                  <Button size="sm" variant="success" onClick={() => updateStatus(u.id, 'approved')}>
                    Approve
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default AdminApprovals;